
import { LogMapper, mappingResults } from './base';
import { GeneralSurgery, SurgeryDiagnosis, SurgeryProcedure } from '@/models/GeneralSurgery'
import { Option } from '@/models/Specialty'

export class GeneralSurgeryMapper extends LogMapper {
  static specialty = 'general-surgery'
  static columns = ['surgery-autonomy', 'sex']

  static components = {
    'surgery-diagnosis': {
      options: () => (SurgeryDiagnosis.query().get().map(mappingResults)),
      checker: super.basicChecker
    },
    'surgery-diagnosis-other': {
      options: this.getTextFieldOptions,
      checker: super.basicChecker
    },
    'surgery-procedure': {
      options: () => (SurgeryProcedure.query().get().map(mappingResults)),
      checker: (log, _, option) => GeneralSurgeryMapper.inArrayChecker(log, 'surgery-procedure-ids', option)
    },
    'surgery-procedure-other': {
      options: this.getTextFieldOptions,
      checker: super.basicChecker
    },
    'surgery-autonomy': {
      options: super.standardOptions,
      checker: (log, _, option) => (log['autonomy'] === option.value)
    },
    'anatomic-region': {
      options: () => {
        const tree = GeneralSurgery.query().first().organTree;
        return tree.flatMap(n => n.children ? [...n.children] : [n]).map(mappingResults)
      },
      checker: GeneralSurgeryMapper.basicChecker
    },
    'internship': {
      options: super.standardOptions,
      checker: super.basicChecker
    }
  }
}

